import posthog from 'posthog-js';
import { env, isProduction } from '@/lib/config/env';

let initialized = false;

// Initializes PostHog for feature-usage tracking. Restricted to production —
// the free PostHog plan is a single project shared across all environments,
// so a staging/dev key would mix non-production usage into the same
// dashboard. Also no-ops when VITE_POSTHOG_KEY is unset.
export function initAnalytics(): void {
  if (initialized || !isProduction || !env.posthogKey) {
    return;
  }
  posthog.init(env.posthogKey, {
    api_host: env.posthogHost,
    autocapture: false,
    capture_pageview: false,
    person_profiles: 'identified_only',
  });
  initialized = true;
}

export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  if (!initialized) {
    return;
  }
  posthog.capture(name, properties);
}

export function identifyUser(distinctId: string, properties?: Record<string, unknown>): void {
  if (!initialized) {
    return;
  }
  posthog.identify(distinctId, properties);
}

export function resetAnalyticsUser(): void {
  if (!initialized) {
    return;
  }
  posthog.reset();
}
